/**
 * @file escalation.js
 * @location src/utils/escalation.js
 * @role 핵심 루프 각 단계의 정체(stall) 판정 — 정체·에스컬레이션 단일 소스
 *
 * task 의 "대기 시작 시각"(acknowledgedAt / task.id) 으로부터 경과 일수(달력일) 를 세어
 * 임계치를 넘으면 stalled. 정체 배지·상사 에스컬레이션이 모두 이 함수를 사용.
 * 새 영속 필드를 추가하지 않고 기존 타임스탬프(task.id·acknowledgedAt) 만으로 계산한다.
 * 주말 포함(영업일 가정 제거) — 주말 근무 업종도 정합. (reviewSince·progressSince 는 razor ㉓ 로 폐기)
 */
import { taskCreatedAtISO } from './ids.js';

/** 단계별 임계치 (일). 운용하며 조정 가능. */
export const STALL_THRESHOLDS = {
  unack: 1,  // 안 읽음 — 발급 후 1일 내 열람 없음
};

/**
 * from(ISO) ~ now 사이 경과 일수(달력일·주말 포함). 같은 날·미래·파싱 불가 시 0.
 * 시각이 아닌 날짜(자정) 기준으로 센다.
 */
export function daysSince(fromISO, now = new Date()) {
  const from = new Date(fromISO);
  if (!Number.isFinite(from.getTime())) return 0;
  const cur = new Date(from.getFullYear(), from.getMonth(), from.getDate());
  const end = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  let count = 0;
  while (cur < end) {
    cur.setDate(cur.getDate() + 1);
    count += 1;
  }
  return count;
}

/** 경과 일수 + 임계 초과(stalled) + 2배 초과(severe) 판정 */
export function stallInfo(sinceISO, threshold, now = new Date()) {
  const days = daysSince(sinceISO, now);
  return { days, stalled: days >= threshold, severe: days >= threshold * 2 };
}

/* ── 단계별 "대기 시작 시각" ── */

/** 안 읽음: 업무 발급 시각 — 명시 createdAt 우선, 폴백은 task.id 역산 (legacy 시드) */
export const assignedSince = (t) => t.createdAt || taskCreatedAtISO(t.id);
